import { createContext, useState, useContext } from "react";
import { Clinic } from "../models";

type ClinicContextType = {
	clinics?: Clinic[];
	setClinics: (value?: Clinic[]) => void;
	telehealthClinics?: Clinic[];
	setTelehealthClinics: (value?: Clinic[]) => void;
	userClinics?: Clinic[];
	setUserClinics: (value?: Clinic[]) => void;
	refreshClinics: boolean;
	setRefreshClinics: (value: boolean) => void;
};

type ClinicContextProviderProps = {
	children: React.ReactNode;
};

const ClinicContext = createContext<ClinicContextType | undefined>(undefined);

export const ClinicProvider = ({ children }: ClinicContextProviderProps) => {
	const [clinics, setClinics] = useState<Clinic[] | undefined>(undefined);
	const [telehealthClinics, setTelehealthClinics] = useState<
		Clinic[] | undefined
	>(undefined);
	const [userClinics, setUserClinics] = useState<Clinic[] | undefined>(
		undefined
	);
	const [refreshClinics, setRefreshClinics] = useState<boolean>(false);

	return (
		<ClinicContext.Provider
			value={{
				clinics,
				setClinics,
				telehealthClinics,
				setTelehealthClinics,
				userClinics,
				setUserClinics,
				refreshClinics,
				setRefreshClinics
			}}
		>
			{children}
		</ClinicContext.Provider>
	);
};

export const useClinicContext = () => {
	const context = useContext(ClinicContext);
	if (context === undefined) {
		throw new Error("useClinicContext must be used within a ClinicProvider");
	}
	return context;
};
